module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_mt_maltese-eabd0a9654e283afd8e2cb653a388e1a.svg";